import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import NftListLayer from "../../components/NFT/NftListLayer";

const NftCollectionsPage = () => {
     return (
          <>
               {/* MasterLayout */}
               <MasterLayout>
                    {/* Breadcrumb */}
                    <Breadcrumb title="NFT List" />

                    {/* NftCollectionsLayer */}
                    <NftListLayer />
               </MasterLayout>
          </>
     );
};

export default NftCollectionsPage;
